<script lang="ts">
  import router from "page"
  import ListGpx from './ListGpx.svelte'
  import DetailsGpx from './DetailsGpx.svelte'

  let page;
  let params;

  router('/', () => page = ListGpx);
  router('/details/:traceId', (ctx, next) => {
    params = ctx.params
    next()
  }, () => page = DetailsGpx);
  router('/*', () => page = DetailsGpx);
  router.start()
</script>

<div class="flex justify-center header shadow-xl z-10">
  <a href="https://tendancetrail.fr" target="_blank">
    <img class="w-24" src="https://tendancetrail.fr/wp-content/uploads/2020/08/logo-TT-250x250-1.jpg" alt="logo tendance trail"/>
  </a>
</div>
<main class="pt-32 pl-3 pr-3">
    <svelte:component this={page} {params} />
<!--    <p class="gray-200 text-center text-xs">By <a class="gray-200" href="https://twitter.com/ValSouche">Tintin</a></p>-->
</main>

<style>
  .header {
    position: fixed;
    width: 100%;
    height: auto;
    background: #fff;
  }
</style>
